import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getUser,
  getAllUser,
  getPrevious,
  getNext,
  getPageUser,
  getCurrentUser,
  createUser,
  updateUser,
  getSpecificUser,
  deleteUser,
  handleSearch,
  deletePhoto,
} from "./thunk";

// initialState
const initialState = {
  users: [],
  edit: false,
  user: null,
  userInfo: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCurrent: false,
  loadingUser: false,
  loadingUpdated: false,
  loadingSpecific: true,
  loadingNext: false,
  showCreateModal: false,
};

//
export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    userEditSuccess: (state, action) => {
      state.edit = true;
      state.loading = false;
      state.loadingUpdated = false;
    },
    clearEditUser: (state) => {
      state.edit = false;
      state.user = null;
      state.loading = false;
      state.loadingUser = false;
      state.loadingUpdated = false;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getNext.pending, (state) => {
      state.loadingNext = true;
    });
    builder.addCase(getNext.fulfilled, (state, action) => {
      state.loadingNext = false;
      state.users = [...state.users, ...action.payload.data];
      state.next = action.payload.next;
    });
    builder.addCase(getNext.rejected, (state) => {
      state.loadingNext = false;
    });

    builder.addCase(getCurrentUser.pending, (state) => {
      state.loadingCurrent = true;
    });
    builder.addCase(getCurrentUser.fulfilled, (state, action) => {
      state.loadingCurrent = false;
      state.userInfo = action.payload.data;
    });
    builder.addCase(getCurrentUser.rejected, (state) => {
      state.loadingCurrent = false;
    });
    builder.addCase(updateUser.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateUser.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateUser.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addCase(getSpecificUser.pending, (state) => {
      state.loadingSpecific = true;
    });
    builder.addCase(getSpecificUser.fulfilled, (state, action) => {
      state.loadingSpecific = false;
      state.user = action.payload.data;
    });
    builder.addCase(getSpecificUser.rejected, (state) => {
      state.loadingSpecific = false;
    });
    builder.addCase(deletePhoto.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(deletePhoto.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.user = action.payload;
    });
    builder.addCase(deletePhoto.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(isAnyOf(getUser.pending, handleSearch.pending), (state) => {
      state.loadingUser = true;
    });
    builder.addMatcher(isAnyOf(getUser.fulfilled, handleSearch.fulfilled), (state, action) => {
      state.loadingUser = false;
      state.users = action.payload.data;
      state.count = action.payload.totalCount;

      state.previous = action.payload.previous;
      state.next = action.payload.next;
    });
    builder.addMatcher(isAnyOf(getUser.rejected, handleSearch.rejected), (state) => {
      state.loadingUser = false;
    });
    builder.addMatcher(isAnyOf(createUser.pending, deleteUser.pending), (state) => {
      state.loading = true;
    });
    builder.addMatcher(isAnyOf(createUser.fulfilled, deleteUser.fulfilled), (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addMatcher(isAnyOf(createUser.rejected, deleteUser.rejected), (state) => {
      state.loading = false;
      state.edit = false;
    });
  },
});

export const { setShowCreateModal, goToPage, userEditSuccess, clearEditUser } = userSlice.actions;

export default userSlice.reducer;
